const anchorLinks = document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]')

anchorLinks.forEach(anchor => {
  anchor?.addEventListener("click", (e) => {
    const targetSelector = anchor.getAttribute("href")
    if (!targetSelector || targetSelector === "#") return
    const target = document.querySelector<HTMLElement>(targetSelector)

    if (!target) return
    e.preventDefault()
    window.scrollTo({top: target.offsetTop, behavior: 'smooth'})
  })
})
